import {create} from 'zustand';

interface Address {
  id: number;
  client_id: number;
  street: string;
  neighborhood: string;
  city: string;
  state: string;
  zip_code: string;
  created_at: string;
  updated_at: string;
}

interface Company {
  id: number;
  name: string;
  clientCode: string;
  cnpj_cpf: string;
  subchannel: string;
  created_at: string;
  updated_at: string;
  user_id: number;
  group_id: number | null;
  ultimoPedido: string;
  dataDeCompra: string;
  group: any | null;
  address: Address | null;
}

interface CompanyState {
  companies: Company[];
  setCompanies: (companies: Company[]) => void;
  addCompany: (company: Company) => void;
  clearCompanies: () => void;
}

export const useCompanyStore = create<CompanyState>(set => ({
  companies: [],

  setCompanies: companies => set({companies}),

  addCompany: company =>
    set(state => ({companies: [...state.companies, company]})),

  clearCompanies: () => set({companies: []}),
}));
